import { Fragment, useState, type ChangeEvent } from "react";
import Modal from "react-responsive-modal";
import Trash from "react-feather/dist/icons/trash";
import Plus from "react-feather/dist/icons/plus";
import { getDaysInMonth } from "date-fns";

import { range } from "../../../../../utils";

import style from "./style.module.scss";
import { Button, LocalEdit, LimitedInput } from "../../../../../ui/";

interface DatesProps {
  month: number;
  year: number;
  dates: Record<number, string>;
  onChange: (dates: Record<number, string>) => void;
  isModalOpened: boolean;
  setModalOpened: (open: boolean) => void;
}

function Dates({ month, year, dates, onChange, isModalOpened, setModalOpened }: DatesProps) {
  const [newDate, setNewDate] = useState<number | null>(null);
  const onToggle = () => setModalOpened(!isModalOpened);
  const onClose = () => setModalOpened(false);
  const firstDay = new Date(year, month, 1);
  const maxDays = getDaysInMonth(firstDay);
  const availableDays = range(maxDays).filter((day) => dates[day] === undefined);
  const onChangeDate = (index: string) => (value: string) => {
    const newDates = {
      ...dates,
      [index]: value,
    };
    onChange(newDates);
  };
  const onRemoveDate = (index: string) => () => {
    const newDates = { ...dates };
    delete newDates[Number(index)];
    onChange(newDates);
  };
  const onNewDate = () => {
    const newDates = {
      ...dates,
      [newDate || availableDays[0]]: "",
    };
    onChange(newDates);
  };

  return (
    <Fragment>
      <Button onClick={onToggle} isPrimary className={style.addButton}>
        <Plus />
      </Button>
      <Modal open={isModalOpened} onClose={onClose}>
        <div className={style.modalContent}>
          <p>
            Ajouter des notes/anniversaires ou autre à certains jour du mois. Ces notes doivent être
            très courtes parce que l'espace disponible est petit.
          </p>
          <div className={style.dates}>
            {Object.entries(dates || {}).map(([index, note]) => (
              <div key={index} className={style.date}>
                <span>Jour: {parseInt(index, 10) + 1}</span>
                <LocalEdit
                  value={note}
                  onChange={onChangeDate(index)}
                  render={({ value, onChange, onPersist }) => (
                    <LimitedInput
                      type="textarea"
                      className={style.text}
                      value={value}
                      onChange={(event) => onChange(event.target.value)}
                      onBlur={onPersist}
                    />
                  )}
                />
                <Button isBorderless onClick={onRemoveDate(index)}>
                  <Trash />
                </Button>
              </div>
            ))}
          </div>
          {availableDays.length !== 0 && (
            <div className={style.newDate}>
              <label>Jour</label>
              <select
                value={newDate ?? ""}
                onChange={(event: ChangeEvent<HTMLSelectElement>) =>
                  setNewDate(Number(event.target.value))
                }
              >
                {availableDays.map((day) => (
                  <option key={day} value={day}>
                    {day + 1}
                  </option>
                ))}
              </select>
              <Button onClick={onNewDate}>Ajouter une note</Button>
            </div>
          )}
          <div className={style.footer}>
            <Button isSecondary onClick={onClose}>
              Valider
            </Button>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
}

export default Dates;
